import { Injectable } from '@angular/core';

import { Effect, Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';

import { NotificationService } from '../../../shared/services/notification.service';
import { AccountsService } from '../../data';

import * as fromActions from '../actions/profile.actions';
import * as fromAuth from '../actions/auth.actions';

@Injectable()
export class ProfileEffects {
  constructor(private actions$: Actions,
    private accountsService: AccountsService,
    private notificationService: NotificationService) { }


  @Effect()
  UpdateProfile$ = this.actions$.ofType(fromActions.ProfileActionTypes.UpdateProfile).pipe(
    map((action: fromActions.UpdateProfile) => action.payload),
    switchMap(userToUpdate => {
      return this.accountsService.updateProfile(userToUpdate).pipe(
        map(user => new fromActions.UpdateProfileSuccess(user)),
        catchError(error => of(new fromActions.UpdateProfileFail(error)))
      );
    })
  );

  @Effect()
  UpdateProfileSuccess$ = this.actions$.ofType(fromActions.ProfileActionTypes.UpdateProfileSuccess).pipe(
    map((action: fromActions.UpdateProfileSuccess) => action.payload),
    map(user => {
      this.notificationService.success('Your account has been updated successfully.');
      return new fromAuth.LoadUserSuccess(user);
    })
  );

  @Effect({ dispatch: false })
  UpdateProfileFail$ = this.actions$.ofType(fromActions.ProfileActionTypes.UpdateProfileFail).pipe(
    map((action: fromActions.UpdateProfileFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );

  @Effect()
  changePassword$ = this.actions$.ofType(fromActions.ProfileActionTypes.ChangePassword).pipe(
    map((action: fromActions.ChangePassword) => action.payload),
    switchMap(model => {
      return this.accountsService.changePassword(model).pipe(
        map(user => new fromActions.ChangePasswordSuccess()),
        catchError(error => of(new fromActions.ChangePasswordFail(error)))
      );
    })
  );

  @Effect({ dispatch: false })
  changePasswordSuccess$ = this.actions$.ofType(fromActions.ProfileActionTypes.ChangePasswordSuccess).pipe(
    map(() => {
        this.notificationService.success('Your password has been updated successfully.');
    })
  );

  @Effect({ dispatch: false })
  changePasswordFail$ = this.actions$.ofType(fromActions.ProfileActionTypes.ChangePasswordFail).pipe(
    map((action: fromActions.ChangePasswordFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );



}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/profile.effects.ts